import React from 'react';
import {  bool, func, node, oneOf } from 'prop-types';
import { NavLink } from 'react-router-dom';
import { PermissionTypes } from '../helpers/permissions';
import usePermissions from '../hooks/usePermissions';

const ProtectedNavLink = ({ children, permissions, isEnabled, ...props }) => {
    const isAllowed = usePermissions(permissions);

    if (!isAllowed || !isEnabled) {
        return null;
    }

    if (props.imgsrc) {
        return (
            <React.Fragment>
                <img src={props.imgsrc} alt="" />
                <NavLink {...props}>
                    {children}
                </NavLink>
            </React.Fragment>
        );
    } else {
        return (
            <NavLink {...props}>
                {children}
            </NavLink>
        );
    }
};

ProtectedNavLink.defaultProps = {
    isEnabled: true
};

ProtectedNavLink.propTypes = {
    children:    node,
    permissions: oneOf(PermissionTypes).isRequired,
    render:      func,
    isEnabled:   bool
};

export default ProtectedNavLink;
